<template>
  <svg
    width="18"
    height="18"
    viewBox="0 0 15 15"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M7 14C5.61553 14 4.26215 13.5895 3.11101 12.8203C1.95987 12.0511 1.06266 10.9579 0.532846 9.67879C0.00303296 8.3997 -0.13559 6.99224 0.134506 5.63437C0.404603 4.2765 1.07129 3.02922 2.05026 2.05026C3.02922 1.07129 4.2765 0.404603 5.63437 0.134506C6.99224 -0.13559 8.3997 0.00303296 9.67879 0.532846C10.9579 1.06266 12.0511 1.95987 12.8203 3.11101C13.5895 4.26215 14 5.61553 14 7C14 8.85652 13.2625 10.637 11.9497 11.9497C10.637 13.2625 8.85652 14 7 14ZM7 1.16667C5.84628 1.16667 4.71846 1.50879 3.75918 2.14976C2.79989 2.79074 2.05222 3.70178 1.61071 4.76768C1.16919 5.83358 1.05367 7.00647 1.27876 8.13803C1.50384 9.26958 2.05941 10.309 2.87521 11.1248C3.69102 11.9406 4.73042 12.4962 5.86198 12.7212C6.99353 12.9463 8.16642 12.8308 9.23232 12.3893C10.2982 11.9478 11.2093 11.2001 11.8502 10.2408C12.4912 9.28154 12.8333 8.15373 12.8333 7C12.8333 5.45291 12.2188 3.96918 11.1248 2.87521C10.0308 1.78125 8.5471 1.16667 7 1.16667Z"
      :fill="props.fillColor"
    />
    <path
      d="M8.98937 9.02443C8.94785 9.06634 8.89838 9.09954 8.84386 9.12208C8.78933 9.14461 8.73086 9.15603 8.67186 9.15566C8.55287 9.15559 8.43878 9.10829 8.35464 9.02415C8.2705 8.94001 8.22319 8.82591 8.22312 8.70692L8.22312 5.76892L5.28512 5.76892C5.16884 5.76481 5.0587 5.71574 4.9779 5.63203C4.89709 5.54832 4.85193 5.43652 4.85193 5.32017C4.85193 5.20383 4.89709 5.09202 4.9779 5.00831C5.0587 4.92461 5.16884 4.87553 5.28512 4.87143L8.67186 4.87143C8.79086 4.8715 8.90495 4.9188 8.98909 5.00294C9.07323 5.08708 9.12053 5.20118 9.12061 5.32017L9.12061 8.70692C9.12097 8.76592 9.10956 8.82439 9.08702 8.87891C9.06448 8.93344 9.03128 8.98291 8.98937 9.02443Z"
      :fill="props.fillColor"
    />
    <path
      d="M8.33927 6.32847L4.95252 9.71521C4.86831 9.79942 4.7541 9.84673 4.63501 9.84673C4.51593 9.84673 4.40172 9.79942 4.31751 9.71521C4.2333 9.631 4.18599 9.51679 4.18599 9.39771C4.18599 9.27862 4.2333 9.16441 4.31751 9.0802L7.70426 5.69345C7.78846 5.60924 7.90267 5.56193 8.02176 5.56193C8.14085 5.56193 8.25506 5.60924 8.33927 5.69345C8.42348 5.77766 8.47079 5.89187 8.47079 6.01096C8.47079 6.13005 8.42348 6.24426 8.33927 6.32847Z"
      :fill="props.fillColor"
    />
  </svg>
</template>

<script setup>
const props = defineProps({
  fillColor: {
    type: String,
    default: "#1B3936",
  },
});
</script>
